export const getShareType = (template) => template?.share_type

export const getShareLink = (template) => template?.share_link

export const getIsGeneratingLink = (template) => template?.isGeneratingLink || false
